<template>
  <div>
    <div class="productBanner"><Banner :classType="2" /></div>
    <Menu v-if= "lang == 'zh'" />
    <div class="pageTitle wow animate__slideInUp" :class="{titleEn:lang == 'en'}">
      <h2>应用领域</h2>
      <p>APPLICATION AREAs</p>
    </div>

    <div class="useSlideW wow animate__slideInUp">
      <Slide :slideList="ContentInfos" :onSlide="onSlide" />
    </div>

    <div class="pageTitle wow animate__slideInUp" ref="three" v-if= "lang == 'zh'">
      <h2>手册下载</h2>
      <p>MANUAL DOWNLOAD</p>
    </div>

    <div class="wrap useBox wow animate__slideInUp" v-if= "lang == 'zh'">
      <NewsList actionTxt="资料下载" :newsList="newsList" down="down" />
    </div>
    <div class="usePageBox" v-if= "lang == 'zh'">
      <Pagination @pageChange="getData" :PagingInfo="PagingInfo"  v-if="showPage"/>
      <p v-else><br/><br/></p>
    </div>

  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import Slide from "./Slide.vue";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      type: this.$route.query.type || "",
      lang: this.$global.lang,
      showPage:false,
      tableData: [
        {
          one: "外观",
          two: "GB/T 26752",
        },
        {
          one: "线密度",
          two: "GB/T3362 附录B",
        },
        {
          one: "拉伸强度",
          two: "GB/T3362",
        },
        {
          one: "拉伸弹性模量",
          two: "GB/T3362",
        },
        {
          one: "断裂伸长率",
          two: "GB/T3362",
        },
        {
          one: "密度",
          two: "GB/T 30019方法C",
        },
        {
          one: "浸润剂含量",
          two: "GB/T 29761 方法A",
        },
        {
          one: "灰分",
          two: "GB/T 26752 附录B",
        },
      ],
      tableData2: [
        {
          one: "拉伸强度",
          two: "ASTM D3039/D 3039M-17 ",
        },
        {
          one: "拉伸弹性模量",
          two: "ASTM D3039/D 3039M-17 ",
        },
        {
          one: "压缩强度",
          two: "ASTM D6641/D 6641M-16",
        },
        {
          one: "压缩弹性模量",
          two: "ASTM D6641/D 6641M-16",
        },
        {
          one: "弯曲强度",
          two: "ASTM D7264/D 7264M-15",
        },
        {
          one: "弯曲弹性模量",
          two: "ASTM D7264/D 7264M-15 ",
        },
        {
          one: "层间剪切强度",
          two: "ASTM D2344/D 2344M-16",
        },
      ],
      newsList: [],
      PagingInfo: {},
      CertificateList: [],
      ContentInfos: [],
      onSlide: sessionStorage.getItem("useId") || 0,
      PicUrl:[],
      TestInfos:[]
    };
  },
  components: {
    Menu,
    Banner,
    NewsList,
    Slide,
    Pagination,
  },
  methods: {
    handleScroll2(type) {
      let threeD = this.$refs.three.offsetTop - 40;
      let meshine =  navigator.userAgent
      var element = meshine.indexOf('Weixin')==-1 ? document.documentElement : document.body;
      element.scrollTop = type ? threeD : note;
    },
    getData(page, type) {
      this.$api
        .fileList({
          Type: 2,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { FileInfos, PagingInfo } = res.Value;
          this.newsList = FileInfos;
          this.PagingInfo = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getTest() {
      this.$api.test().then((res) => {
        const { CertificateList,PicUrl,TestInfos, } = res.Value;
        this.CertificateList = CertificateList;
        this.PicUrl = PicUrl
        this.TestInfos = TestInfos
      });
    },
    getUse() {
      this.$api.rearch({ Type: 2 }).then((res) => {
        console.log(res.Value,'33333')
        const { ContentInfos } = res.Value;
        this.ContentInfos = ContentInfos;
      });
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        this.onSlide = this.$route.params.id;
        if (this.type == "two") {
          this.handleScroll2();
        }
        if (this.type == "three") {
          this.handleScroll2("2");
        }
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;
    this.onSlide = sessionStorage.getItem("useId") || 0;

    if (this.type == "two") {
      this.handleScroll2();
    }
    if (this.type == "three") {
      this.handleScroll2("2");
    }
    this.getUse();
    this.getData(1, "first");
    this.getTest();
  },
  destroyed() {
    sessionStorage.removeItem("useId");
  },
};
</script>

<style lang="scss">
.useMG {
  margin-top: 50px;
  padding-bottom: 50px;
}
.useBox {
  padding: 50px 0 0 0;
}
.useH2 {
  background-color: #f3f3f3;
  font-weight: 400;
  line-height: 55px;
  text-align: center;
  padding: 0 0 0 10px;
  border-bottom: 1px solid #ddd;
}
.tableBox {
  .el-table {
    margin-bottom: 50px;
    thead {
      color: #000;
    }
  }
  .el-table th.el-table__cell {
    background-color: #f9f9f9;
  }
}
.useImg {
  width: 100%;
}
.useDown {
  border: 1px solid #bfbfbf;
  line-height: 25px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.useSlideW {
  padding: 50px 0;
}
</style>